import React from "react";

// eslint-disable-next-line import/prefer-default-export
export const CONFIRMATION_DIALOG_NO_THOUSANDS_SEPARATOR = {
  text: <>Dots and commas are used as decimal separator. Thousands separators should not be used.</>,
};
